const youtubeRegex = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
const vimeoRegex = /(?:http|https)?:?\/?\/?(?:www\.|player\.)?vimeo\.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^/]*)\/videos\/|video\/|)(\d+)(?:|\/\?)/;
const codepenRegex = /(?:http|https)?:?\/?\/?(?:www\.)?codepen\.io\/([^#&?]*)\/pen\/([^#&?]*)/;
const codesandboxRegex = /(?:http|https)?:?\/?\/?(?:www\.)?codesandbox\.io(.*)/;
var URLType = /* @__PURE__ */ ((URLType2) => {
  URLType2["youtube"] = "youtube";
  URLType2["vimeo"] = "vimeo";
  URLType2["codepen"] = "codepen";
  URLType2["codesandbox"] = "codesandbox";
  URLType2["fallback"] = "";
  return URLType2;
})(URLType || {});
function getValidatedSrc(src) {
  const youtubeMatch = src.match(youtubeRegex);
  const vimeoMatch = src.match(vimeoRegex);
  const codepenMatch = src.match(codepenRegex);
  const codesandboxMatch = src.match(codesandboxRegex);
  if (youtubeMatch?.[2].length === 11) {
    return {
      src: `https://www.youtube.com/embed/${youtubeMatch[2]}`,
      type: "youtube" /* youtube */
    };
  }
  if (vimeoMatch?.[1]) {
    return {
      src: `https://player.vimeo.com/video/${vimeoMatch[1]}`,
      type: "vimeo" /* vimeo */
    };
  }
  if (codepenMatch?.[1] && codepenMatch[2]) {
    return {
      src: `https://codepen.io/${codepenMatch[1]}/embed/preview/${codepenMatch[2]}?default-tabs=html%2Cresult&height=600&host=https%3A%2F%2Fcodepen.io&slug-hash=${codepenMatch[2]}`,
      type: "codepen" /* codepen */
    };
  }
  if (codesandboxMatch?.[1]) {
    return {
      src: `https://codesandbox.io${codesandboxMatch[1]}`,
      type: "codesandbox" /* codesandbox */
    };
  }
  return {
    src,
    type: "" /* fallback */
  };
}
function formatAttributes(props) {
  return Object.entries(props).map(([key, value]) => value === true ? key : `${key}="${value}"`).filter(Boolean).join(" ");
}
function getIframeAttributes(src) {
  const validatedSrc = getValidatedSrc(src);
  if (validatedSrc.type === "youtube" /* youtube */) {
    const regex = /http(?:s?):\/\/(?:www\.)?youtu(?:be\.com\/watch\?v=|\.be\/)([\w-_]*)/;
    const matches = src.match(regex);
    return formatAttributes({
      title: "YouTube video player",
      allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
      allowfullscreen: true,
      frameborder: "0",
      src: matches?.[1] ? `https://www.youtube.com/embed/${matches[1]}` : src
    });
  }
  if (validatedSrc.type === "codesandbox" /* codesandbox */) {
    const style = Object.entries({
      "width": "100%",
      "height": "500px",
      "border": "0px",
      "border-radius": "4px",
      "overflow": "hidden"
    }).map(([key, value]) => `${key}: ${value}`).join("; ");
    return formatAttributes({
      allow: "geolocation; microphone; camera; midi; vr; accelerometer; gyroscope; payment; ambient-light-sensor; encrypted-media; usb",
      class: "codeanysandbox-mdx-embed",
      "data-testid": "codesandbox",
      sandbox: "allow-modals allow-forms allow-popups allow-scripts allow-same-origin",
      style,
      title: "codeSandbox-rz330",
      src
    });
  }
  if (validatedSrc.type === "vimeo" /* vimeo */) {
    const regex = new RegExp(
      /(http|https)?:\/\/(www\.|player\.)?vimeo\.com\/(?:channels\/(?:\w+\/)?|groups\/([^/]*)\/videos\/|video\/|)(\d+)(?:|\/\?)/
    );
    const matches = src.match(regex);
    return formatAttributes({
      title: "Vimeo video player",
      allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
      allowfullscreen: true,
      frameborder: "0",
      src: matches?.[4] ? `https://player.vimeo.com/video/${matches[4]}` : src
    });
  }
  return formatAttributes({
    allow: "autoplay; fullscreen; picture-in-picture",
    allowfullscreen: true,
    frameborder: "0",
    src
  });
}
export {
  getIframeAttributes
};
//# sourceMappingURL=validate-src.js.map
